import { CopyButton } from '@@/ui/primitives';

export const DetailField = (props: { label: string; value: unknown; isDate?: boolean }) => {
  const isString = typeof props.value === 'string' || props.value instanceof String;
  const formatValue = (value: unknown) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (typeof value === 'string' && value.trim() === '') return '<empty>';
    if (typeof value === 'object') {
      return (
        <pre className='text-xs bg-neutral-100 mt-2 p-3 px-4 rounded-lg overflow-auto whitespace-pre-wrap '>
          {JSON.stringify(value, null, 2)}
        </pre>
      );
    }

    return String(value);
  };

  const formatDate = (dateString?: string) => {
    if (!dateString) return '-';
    try {
      return new Date(dateString).toLocaleString();
    } catch {
      return dateString;
    }
  };

  const displayValue = props.isDate ? formatDate(props.value as string) : formatValue(props.value);

  return (
    <div className='group flex flex-col gap-1 not-last:border-b not-last:border-neutral-100 py-1.5'>
      <dt className='text-xs font-medium text-neutral-700'>{props.label}</dt>
      <dd className={`whitespace-pre-wrap text-sm text-neutral-950`}>
        {displayValue}
        {isString && <CopyButton content={props.value as string} hideByDefault />}
      </dd>
    </div>
  );
};
